// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

export const CatalogueVideoFragmentDoc = `
    fragment catalogueVideo on CatalogueVideo {
  __typename
  uri
  type
}
    `;